import { FC, memo } from 'react';
import { ReceiptArchiveFilterForm, IReceiptArchiveFilterForm } from './ReceiptArchiveFilterForm';

const ReceiptArchiveFilter: FC<IReceiptArchiveFilterForm> = memo((props) => (
  <ReceiptArchiveFilterForm {...props} />
));

export { ReceiptArchiveFilter };
